<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        @if (!vm.promoEnded && !vm.optInDetails.hideOptin) {
            <div class="d-flex w-100 mb-5 mt-4 mb-sm-3">
                <!-- OPT IN MODULE -->
                @if (vm.optInDetails.isOptinRequired && !vm.optInDetails.isOptedIn) {
                    <ds-card
                        [elevated]="dsComponents?.dsCardStatic?.elevated"
                        [variant]="dsComponents?.dsCardStatic?.variant"
                        class="opt-in-step w-100"
                        [ngClass]="{
                            'opt-in-step-btn': !vm.optInContent.keyTermsAndConditions,
                            'stickyOptInTime': device.isMobile,
                            'tp-opt-in': isRankingV2Enabled != 'true',
                            'tp-opt-in-v2': isRankingV2Enabled == 'true',
                        }"
                        [ngStyle]="{
                            'background-image': 'URL(' + vm.optInContent.backgroundImage?.image?.src + ')',
                            'background-repeat': 'no-repeat',
                        }">
                        @if (vm.optInContent.keyTermsAndConditions) {
                            <span class="opt-in-step-content" [vnDynamicHtml]="vm.optInContent.keyTermsAndConditions"></span>
                        }
                        <a
                            grayoutStyle
                            [isDisabled]="!isOptInAllowed"
                            [onClickWebTracker]="{
                                LabelEvent: vm.webAnalyticModel.page,
                                ActionEvent: 'Opt-in - Click',
                                PositionEvent: vm.webAnalyticModel.tab,
                                LocationEvent: vm.webAnalyticModel.promoId,
                                EventDetails: 'Details Page Footer',
                                campaignId: vm.webAnalyticModel.campaignId,
                                messageType: vm.webAnalyticModel.messageType,
                            }"
                            [ngClass]="{ 'w-100 opt-in-btn': !vm.optInContent.keyTermsAndConditions }"
                            ds-button
                            [size]="dsOptinConfig?.size"
                            [variant]="dsOptinConfig?.variant"
                            [kind]="dsOptinConfig?.kind"
                            href="#"
                            (click)="optedInClicked(); $event.preventDefault()">
                            {{ vm.commonContentMessages.optinbuttontext }}
                        </a>
                    </ds-card>
                }
                <!-- OPT IN MODULE WITH TIMER -->
                @if (vm.optInDetails.isOptedIn || !vm.optInDetails.isOptinRequired) {
                    <ds-card
                        [elevated]="dsComponents?.dsCardStatic?.elevated"
                        [variant]="dsComponents?.dsCardStatic?.variant"
                        class="opt-in-time w-100"
                        [ngClass]="{
                            'stickyOptInTime': device.isMobile,
                            'tp-opt-in': isRankingV2Enabled != 'true',
                            'tp-opt-in-v2': isRankingV2Enabled == 'true',
                        }"
                        [ngStyle]="{
                            'background-image': 'URL(' + vm.optInContent.backgroundImage?.image?.src + ')',
                            'background-repeat': 'no-repeat',
                        }">
                        <div class="date-time-wrapper">
                            <span class="date-time-header">
                                {{
                                    vm.promoStarted
                                        ? vm.commonContentMessages.optintimerfinishingintext
                                        : vm.commonContentMessages.optintimerstartingintext
                                }}
                            </span>
                            @if (vm.optInContent.backgroundImage?.parameters; as parameters) {
                                <span class="date-time" [tpCountDownTimer]="vm.countDownTime" (timeOut)="onTimeOut()">
                                    <span #days></span><small>{{ parameters.days }}</small> <span #hours></span><small>{{ parameters.hours }}</small>
                                    <span #minutes></span><small>{{ parameters.minutes }}</small> <span #seconds></span
                                    ><small>{{ parameters.seconds }}</small>
                                </span>
                            }
                        </div>
                        @if (vm.promoStarted) {
                            <a
                                grayoutStyle
                                [isDisabled]="!isOptInAllowed"
                                [onClickWebTracker]="{
                                    LabelEvent: vm.webAnalyticModel.page,
                                    ActionEvent: 'Play Now  - Click',
                                    LocationEvent: vm.webAnalyticModel.tab,
                                    EventDetails: vm.webAnalyticModel.promoId,
                                    URLClicked: vm.optInContent.playNow?.url,
                                    campaignId: vm.webAnalyticModel.promoId,
                                    messageType: vm.webAnalyticModel.messageType,
                                }"
                                ds-button
                                [size]="vm?.optInContent?.playNow?.attributes['data-btn-size'] ?? dsPlayNowButtonConfig?.dsButton?.size"
                                [variant]="vm?.optInContent?.playNow?.attributes['data-btn-variant'] ?? dsPlayNowButtonConfig?.dsButton?.variant"
                                [kind]="vm?.optInContent?.playNow?.attributes['data-btn-kind'] ?? dsPlayNowButtonConfig?.dsButton?.kind"
                                [onClickOpenLink]="vm.optInContent.playNow"
                                [isCashierButton]="false">
                                {{ vm.optInContent.playNow?.text }}
                            </a>
                        } @else {
                            @if (vm.optInDetails.isOptinRequired && vm.optInDetails.isOptedIn) {
                                <div class="success-wrapper">
                                    <span class="theme-success-i"></span>
                                    <span class="success-text">
                                        {{ vm.commonContentMessages.optedintext }}
                                    </span>
                                </div>
                            }
                        }
                    </ds-card>
                }
            </div>
        }
    }
</ng-container>
